<script>
	import { store } from "$lib/utilities/store";
	import FormReview from "$lib/sections/FormSubmission/FormReview.svelte";
	import { getSections } from "$lib/sections/FormSubmission/getSections";

	export let record = {};
	export let col = "calls";
	export let lang = "";

	$: formId =
		typeof record?.formId === "string" ? record.formId.trim() : "";
	$: form = formId ? $store?.forms?.docs?.[formId] : undefined;
	$: sections = form ? getSections(form, lang, "") : [];
</script>

{#if formId}
	{#if form && sections.length}
		<FormReview {sections} responses={record} {col} {lang} />
	{:else}
		<p class="rounded-lg bg-warning/10 p-4 text-warning-content">
			The configured intake form is not available in this session.
		</p>
	{/if}
{/if}
